import styled from 'styled-components';
import  Select  from 'react-select';
export const SelectWrapper = styled.div`
  margin-bottom: 24px;
  width: 100%;
  position: relative;
`;

export const SelectLabel = styled.label`
  display: block;
  font-size: 16px;
  font-weight: 400;
  color: #1a1a1a;
  margin-bottom: 12px;
  font-family: 'Inter', sans-serif;
`;

export const RequiredAsterisk = styled.span`
  color: #1a1a1a;
  margin-left: 2px;
  font-size: 16px;
`;

export const ErrorMessage = styled.p`
  color: #f73450;
  font-size: 0.875rem;
  margin-top: 0.25rem;
  display: block;
`;

export const SelectContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  background-color: ${(props) => (props.isDisabled ? '#fafafa' : 'white')};
  border: 1.5px solid ${(props) => (props.hasError ? '#f73450' : '#e0e0e0')};
  border-radius: 50px;
  padding: 0 20px;
  transition: all 0.2s ease;
  cursor: ${(props) => (props.isDisabled ? 'not-allowed' : 'pointer')};
  outline: none;

  ${(props) =>
    props.isFocused &&
    !props.isDisabled &&
    !props.hasError &&
    `
    border-color: #b0b0b0;
    box-shadow: 0 0 0 3px rgba(0, 0, 0, 0.03);
  `}

  ${(props) =>
    props.hasError &&
    `
    border-color: #f73450;
    box-shadow: 0 0 0 3px rgba(247, 52, 80, 0.1);
  `}

  &:focus-visible {
    border-color: #b0b0b0;
    box-shadow: 0 0 0 3px rgba(0, 0, 0, 0.03);
  }
`;

export const SelectIcon = styled.span`
  display: flex;
  align-items: center;
  margin-right: 12px;
  color: ${(props) => (props.isDisabled ? '#999' : '#666')};
  font-size: 20px;
`;

export const SelectField = styled.div`
  flex: 1;
  font-size: 16px;
  color: ${(props) => (props.hasValue ? '#1a1a1a' : '#999')};
  padding: 0.8em 0;
  font-weight: 400;
  font-family: 'Inter', sans-serif;
  cursor: ${(props) => (props.isDisabled ? 'not-allowed' : 'pointer')};
  user-select: none;

  ${(props) =>
    props.isDisabled &&
    `
    color: #999;
  `}
`;

export const SelectArrow = styled.span`
  display: flex;
  align-items: center;
  margin-left: 12px;
  color: ${(props) => (props.isDisabled ? '#999' : '#666')};
  font-size: 12px;
  transition: transform 0.2s ease;
  transform: ${(props) => (props.isOpen ? 'rotate(180deg)' : 'rotate(0deg)')};
`;

export const OptionsContainer = styled.div`
  position: absolute;
  top: calc(100% + 8px);
  left: 0;
  right: 0;
  background-color: white;
  border: 1.5px solid #e0e0e0;
  border-radius: 16px;
  max-height: 240px;
  overflow-y: auto;
  z-index: 1000;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);

  /* Scrollbar customizada */
  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 10px;
  }

  &::-webkit-scrollbar-thumb {
    background: #c0c0c0;
    border-radius: 10px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #a0a0a0;
  }
`;

export const Option = styled.div`
  padding: 12px 20px;
  font-size: 16px;
  color: #1a1a1a;
  font-family: 'Inter', sans-serif;
  cursor: pointer;
  transition: background-color 0.2s ease;
  background-color: ${(props) => (props.isSelected ? '#f5f5f5' : 'white')};

  &:hover {
    background-color: #f5f5f5;
  }

  &:first-child {
    border-radius: 14px 14px 0 0;
  }

  &:last-child {
    border-radius: 0 0 14px 14px;
  }

  &:only-child {
    border-radius: 14px;
  }
`;

export const StyledSelect = styled(Select)`
  .react-select__control {
    background-color: ${(props) => (props.isDisabled ? '#fafafa' : 'white')};
    border: 1.5px solid ${(props) => (props.hasError ? '#f73450' : '#e0e0e0')};
    border-radius: 50px;
    padding: 0 20px;
    min-height: auto;
    cursor: ${(props) => (props.isDisabled ? 'not-allowed' : 'pointer')};
    outline: none;
    transition: all 0.2s ease;
    box-shadow: none;

    &:hover {
      border-color: ${(props) =>
        props.isDisabled ? '#e0e0e0' : props.hasError ? '#f73450' : '#b0b0b0'};
    }

    &--is-focused {
      border-color: ${(props) => (props.hasError ? '#f73450' : '#b0b0b0')};
      box-shadow: ${(props) =>
        props.hasError
          ? '0 0 0 3px rgba(247, 52, 80, 0.1)'
          : '0 0 0 3px rgba(0, 0, 0, 0.03)'};
    }
  }

  .react-select__value-container {
    padding: 0.8em 0;
    display: flex;
    align-items: center;
  }

  .react-select__placeholder {
    color: #999;
    font-size: 16px;
    font-weight: 400;
    font-family: 'Inter', sans-serif;
    margin: 0;
  }

  .react-select__single-value {
    color: #1a1a1a;
    font-size: 16px;
    font-weight: 400;
    font-family: 'Inter', sans-serif;
    margin: 0;
  }

  .react-select__input-container {
    margin: 0;
    padding: 0;
  }

  .react-select__indicator-separator {
    display: none;
  }

  .react-select__dropdown-indicator {
    padding: 0;
    margin-left: 12px;
  }

  .react-select__menu {
    margin-top: 8px;
    border-radius: 16px;
    border: 1.5px solid #e0e0e0;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
    overflow: hidden;
  }

  .react-select__menu-list {
    padding: 0;
    max-height: 240px;
    border-radius: 16px;

    &::-webkit-scrollbar {
      width: 6px;
    }

    &::-webkit-scrollbar-track {
      background: #f1f1f1;
      border-radius: 10px;
    }

    &::-webkit-scrollbar-thumb {
      background: #c0c0c0;
      border-radius: 10px;
    }

    &::-webkit-scrollbar-thumb:hover {
      background: #a0a0a0;
    }
  }

  .react-select__option {
    padding: 12px 20px;
    font-size: 16px;
    color: #1a1a1a;
    font-family: 'Inter', sans-serif;
    cursor: pointer;
    transition: background-color 0.2s ease;

    &--is-focused {
      background-color: #f5f5f5;
    }

    &--is-selected {
      background-color: #f5f5f5;
    }

    &:active {
      background-color: #f5f5f5;
    }
  }
`;

export const IconWrapper = styled.span`
  display: flex;
  align-items: center;
  margin-right: 12px;
  color: ${(props) => (props.isDisabled ? '#999' : '#666')};
  font-size: 20px;
`;

export const ArrowIcon = styled.span`
  display: flex;
  align-items: center;
  font-size: 12px;
  color: ${(props) => (props.isDisabled ? '#999' : '#666')};
  transition: transform 0.2s ease;
  transform: ${(props) => (props.isOpen ? 'rotate(180deg)' : 'rotate(0deg)')};
`;
